/**
 * @fileoverview Provide shared presentation and controlled-field vocabulary for Intake detail surfaces. Consuming panels own data, validation, and business actions; these primitives own labels, badges, empty states, and repeated record layouts. `intakeFormatters.js` supplies consistent domain display semantics.
 */

import React from 'react';
import { getRecordStatusClass, titleize } from './intakeFormatters';
import AppIcon from "../shared/AppIcon";



export function IntakeBadge({ value, className = '' }) {
  return <span className={`intake-badge ${className || getRecordStatusClass(value)}`}>{titleize(value)}</span>;
}



export function IntakeField({ label, value, wide = false }) {
  return (
    <div className={`intake-detail-field${wide ? ' intake-detail-field--wide' : ''}`}>
            <span>{label}</span>
            <strong>{value || '-'}</strong>
        </div>);

}



export function IntakeTerm({ label, value }) {
  return (
    <div className="intake-field">
            <dt>{label}</dt>
            <dd>{value || '-'}</dd>
        </div>);

}



export function EmptyState({ title }) {
  return (
    <div className="intake-empty-state">
            <AppIcon icon="pi pi-inbox" aria-hidden="true" />
            <span>{title}</span>
        </div>);

}



export function TextInput({ label, value, onChange, type = 'text', disabled = false }) {
  return (
    <label className="intake-form-field">
            <span>{label}</span>
            <input type={type} value={value || ''} disabled={disabled} onChange={(event) => onChange(event.target.value)} />
        </label>);

}



export function TextArea({ label, value, onChange, rows = 4, disabled = false }) {
  return (
    <label className="intake-form-field intake-form-field--wide">
            <span>{label}</span>
            <textarea value={value || ''} rows={rows} disabled={disabled} onChange={(event) => onChange(event.target.value)} />
        </label>);

}



export function SelectInput({ label, value, onChange, options, disabled = false }) {
  return (
    <label className="intake-form-field">
            <span>{label}</span>
            <select value={value || ''} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
                {options.map(([optionValue, optionLabel]) =>
        <option key={optionValue} value={optionValue}>{optionLabel}</option>
        )}
            </select>
        </label>);

}



export function CheckboxInput({ label, checked, onChange }) {
  return (
    <label className="intake-checkbox-row intake-checkbox-row--boxed">
            <input type="checkbox" checked={Boolean(checked)} onChange={(event) => onChange(event.target.checked)} />
            <span>{label}</span>
        </label>);

}



export function RecordList({ title, loading, empty, children }) {
  const hasChildren = React.Children.count(children) > 0;
  return (
    <section className="intake-record-list-wrap">
            <div className="intake-section-heading">
                <h2>{title}</h2>
            </div>
            {loading && <EmptyState title="Loading records..." />}
            {!loading && !hasChildren && <EmptyState title={empty} />}
            {!loading && hasChildren && <div className="intake-record-list">{children}</div>}
        </section>);

}
